import { useEffect } from "react";
import { CanvasDrawer } from "../utils/drawer.js";
import { getCanvasContext } from "../utils/canvas.js";

export function useMonitor(args: {
  canvasDrawer?: CanvasDrawer;
  id?: string;
  showMonitor?: boolean;
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
}) {
  const {
    canvasDrawer,
    id = String(Math.random()),
    showMonitor,
    top,
    right,
    bottom,
    left,
  } = args;
  useEffect(() => {
    const queryId = `canvas#${id}`;
    if (!showMonitor) {
      const monitor = document.querySelector(queryId);
      monitor && document.body.removeChild(monitor);

      return;
    }
    const monitor = (() => {
      let monitor: HTMLCanvasElement | null = document.querySelector(queryId);
      if (monitor) return monitor;
      monitor = document.createElement("canvas");
      monitor.id = id;
      monitor.style.position = "fixed";
      if (top) monitor.style.top = top;
      if (right) monitor.style.right = right;
      if (bottom) monitor.style.bottom = bottom;
      if (left) monitor.style.left = left;
      monitor.style.border = "1px solid red";
      monitor.width = 200;
      monitor.height = 200;
      document.body.appendChild(monitor);
      return monitor;
    })();

    const listener = canvasDrawer?.observable.subscribe(({ status }) => {
      if (!status) return;
      monitor.width =
        (monitor.height * canvasDrawer.canvas.width) /
        canvasDrawer.canvas.height;
      const context = getCanvasContext({ canvas: monitor });
      context.clearRect(0, 0, monitor.width, monitor.height);
      context.drawImage(
        canvasDrawer.canvas,
        0,
        0,
        monitor.width,
        monitor.height
      );
    });
    return () => {
      listener && listener();
    };
  }, [showMonitor, canvasDrawer]);
  return { id };
}
